export const RouteConstants = {
    LOGIN: "/login",
    AUTH_ERROR: "/auth-error",
    UNAUTHORIZED: "/unauthorized",
    AUTH_CALLBACK: "/callback",
    LOGOUT: "/logout",
};